import { Types } from '../../types/types';

export function colors(colors) {
    return {
        type: Types.COLORS,
        payload: colors
    };
}
